import { IJsonQuery, EElevators } from '@cian/api-models/common/json_query';

import { EElevatorType } from './types';
import { getTermValue, getRangeValue } from './helpers';

export function getElevatorType(jsonQuery: IJsonQuery): EElevatorType | null {
  const serviceElevators = getRangeValue('lift_service')(jsonQuery);
  const elevators = getTermValue('lifts')(jsonQuery);

  switch (true) {
    case serviceElevators && serviceElevators.gte && serviceElevators.gte > 0:
      return EElevatorType.Service;

    case elevators !== null && elevators !== EElevators.Any:
      return EElevatorType.Any;
  }

  return null;
}
